"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    MSG_HEARTBEAT: 1,
    MSG_AUTH_TOKEN: 2,

    MSG_AUTH_STATUS: 3,
    //persistent
    MSG_IM: 4,
    MSG_ACK: 5,

    //deprecated
    MSG_RST: 6,

    //persistent
    MSG_GROUP_NOTIFICATION: 7,
    MSG_GROUP_IM: 8,

    //deprecated
    MSG_PEER_ACK: 9,
    MSG_INPUTING: 10,

    MSG_ENTER_ROOM: 18,
    MSG_LEAVE_ROOM: 19,
    MSG_ROOM_IM: 20,

    //客户端->服务端
    MSG_SYNC: 26, //同步消息
    //服务端->客服端
    MSG_SYNC_BEGIN: 27,
    MSG_SYNC_END: 28,
    //通知客户端有新消息
    MSG_SYNC_NOTIFY: 29,

    //客户端->服务端
    MSG_SYNC_GROUP: 30, //同步超级群消息
    //服务端->客服端
    MSG_SYNC_GROUP_BEGIN: 31,
    MSG_SYNC_GROUP_END: 32,
    //通知客户端有新消息
    MSG_SYNC_GROUP_NOTIFY: 33,

    //客服端->服务端,更新服务器的synckey
    MSG_SYNC_KEY: 34,
    MSG_GROUP_SYNC_KEY: 35,

    MSG_SYSTEM: 36,

    MSG_TRANSMISSION: 37,

    MSG_RESULT: 38,

    MSG_ROOM_GET_STATE: 39,

    MSG_ROOM_STATE: 40,

    MSG_ROOM_SET_STATE: 41,

    MSG_ROOM_NOTIFY: 42,

    // 以下为 systemmessage 的msgid
    SYS_ANOTHER: 51,
    SYS_ROOM_ENTER: 52,
    SYS_ROOM_LEAVE: 53,
    SYS_CUSTOM: 54,

    // 登录平台 id
    PLATFORM_ANDROID: 101,
    PLATFORM_IOS: 102,
    PLATFORM_WEB: 201,
    PLATFORM_PC: 301

};
//# sourceMappingURL=constant.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ciim_sdk@3.0.8@ciim_sdk/dist/im/constant.js
// module id = OVks
// module chunks = 0